export const DEFAULT_EMAIL_MESSAGE_STREAM = 'checkout-automation';
export const DEFAULT_EMAIL_FROM_EMAIL = 'contact@couteausuissedigital.com';
export const DEFAULT_EMAIL_REPLY_TO = 'contact@couteausuissedigital.com';
export const DEFAULT_ADMIN_EMAIL = 'admin@couteausuissedigital.com';
export const DEFAULT_COMPANY_NAME = 'Couteau Suisse Digital';
export const DEFAULT_COMPANY_PHONE = '+41 79 65 38 00';
export const DEFAULT_SITE_URL = 'https://couteausuissedigital.com';

const createSampleModel = (overrides = {}) => ({
  customer_first_name: 'Jean',
  customer_name: 'Jean Dupont',
  client_name: 'Jean Dupont',
  customer_email: 'jean.dupont@example.com',
  client_email: 'jean.dupont@example.com',
  client_phone: '+33 6 12 34 56 78',
  client_country: 'France',
  product_name: 'Tunnel de vente premium',
  service_name: 'Tunnel de vente premium',
  order_number: 'CMD-2026-0001',
  order_date: '23 avril 2026',
  order_url: `${DEFAULT_SITE_URL}/commande/CMD-2026-0001`,
  invoice_url: `${DEFAULT_SITE_URL}/documents/facture/FAC-2026-0001`,
  invoice_number: 'FAC-2026-0001',
  invoice_date: '23 avril 2026',
  quote_url: `${DEFAULT_SITE_URL}/documents/devis/DEV-2026-0001`,
  quote_number: 'DEV-2026-0001',
  quote_date: '23 avril 2026',
  quote_valid_until: '30 avril 2026',
  accept_quote_url: `${DEFAULT_SITE_URL}/documents/devis/DEV-2026-0001#accepter`,
  checkout_url: `${DEFAULT_SITE_URL}/payment/tunnel-premium`,
  dashboard_url: `${DEFAULT_SITE_URL}/commande/CMD-2026-0001`,
  booking_url: `${DEFAULT_SITE_URL}/reserver`,
  billing_url: `${DEFAULT_SITE_URL}/documents/facture/FAC-2026-0001#paiement`,
  support_url: `${DEFAULT_SITE_URL}/contact`,
  payment_method: 'Carte bancaire',
  quantity: '1',
  amount: '441.00',
  amount_with_currency: '441.00 CAD',
  total_price: '441.00 CAD',
  line_total: '441.00 CAD',
  subtotal: '441.00 CAD',
  tax_amount: '0.00 CAD',
  total_amount: '441.00 CAD',
  currency_code: 'CAD',
  service_label: 'Tunnel de vente premium',
  company_email: DEFAULT_EMAIL_FROM_EMAIL,
  support_email: DEFAULT_EMAIL_REPLY_TO,
  company_phone: DEFAULT_COMPANY_PHONE,
  company_website: DEFAULT_SITE_URL,
  current_year: '2026',
  checkout_token: 'checkout_123',
  customer_company: 'Entreprise Demo',
  email_title: 'Votre message CSD',
  email_label: 'Communication personnalisée',
  hero_title: 'Un message important pour vous',
  hero_text:
    'Bonjour Jean, nous vous contactons pour partager une information importante concernant votre projet.',
  primary_button_url: `${DEFAULT_SITE_URL}/contact`,
  primary_button_text: 'Voir les détails',
  section_title: 'Ce que vous devez savoir',
  section_text:
    'Ajoutez ici le contenu principal de votre email pour expliquer clairement la suite.',
  box_content: 'Bloc complémentaire avec détails, dates, avantages ou éléments utiles.',
  note_title: 'Bon à savoir',
  note_text: 'Ajoutez ici une note, un rappel ou une instruction importante.',
  secondary_button_url: `${DEFAULT_SITE_URL}/contact`,
  secondary_button_text: 'Contacter le support',
  custom_html_block:
    '<div style="font-size:14px; line-height:22px; color:#4b5563;">Bloc HTML personnalisé.</div>',
  ...overrides,
});

export const getDefaultEmailTemplatePresets = ({
  messageStream = DEFAULT_EMAIL_MESSAGE_STREAM,
  fromEmail = DEFAULT_EMAIL_FROM_EMAIL,
  replyTo = DEFAULT_EMAIL_REPLY_TO,
} = {}) => [
  {
    templateKey: 'purchase_confirmation',
    name: 'Confirmation de votre achat',
    alias: 'checkout-purchase-confirmation',
    subject: 'Confirmation de votre achat — Couteau Suisse Digital',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Confirmation de votre achat</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1; margin:0; padding:0;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background-color:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; background-color:#ffffff; border-bottom:1px solid #f1ece8;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td align="left" style="font-size:38px; font-weight:800; color:#ff6a00; letter-spacing:-1px;">
                    CSD
                  </td>
                  <td align="right" style="font-size:13px; color:#6b7280;">
                    Couteau Suisse Digital
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td align="left" style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">
                    Confirmation d’achat
                  </td>
                </tr>
                <tr>
                  <td align="left" style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">
                    Merci pour votre confiance.
                  </td>
                </tr>
                <tr>
                  <td align="left" style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                    Bonjour {{customer_first_name}},<br><br>
                    Nous confirmons que votre achat a bien été enregistré. Notre équipe prépare maintenant la suite pour vous offrir une expérience simple, rapide et professionnelle.
                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <a href="{{order_url}}" style="display:inline-block; background-color:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                      Voir ma commande
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:34px 32px 10px 32px;">
              <div style="font-size:24px; line-height:32px; font-weight:800; color:#111827; margin-bottom:20px;">
                Récapitulatif de votre achat
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Numéro de commande</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{order_number}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Date</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{order_date}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Service / Offre</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{product_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Montant total</td>
                        <td align="right" style="font-size:18px; font-weight:800; color:#ff6a00; padding-bottom:8px;">{{total_price}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Mode de paiement</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{payment_method}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:24px 32px 10px 32px;">
              <div style="font-size:16px; line-height:28px; color:#4b5563;">
                Vous recevrez prochainement les prochaines informations concernant votre achat à l’adresse :
                <strong style="color:#111827;">{{customer_email}}</strong>.
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:20px 32px 10px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Bon à savoir :</strong><br>
                    Si vous avez réservé un service ou un accompagnement, notre équipe vous contactera rapidement pour organiser la mise en place et les prochaines étapes.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:30px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Besoin d’aide ? Contactez notre équipe
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background-color:#111827;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">
                    CSD
                  </td>
                </tr>
                <tr>
                  <td style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                    Couteau Suisse Digital<br>
                    Des solutions numériques pensées pour faire avancer votre entreprise.
                  </td>
                </tr>
                <tr>
                  <td style="font-size:13px; line-height:22px; color:#9ca3af;">
                    Email : {{company_email}}<br>
                    Téléphone : {{company_phone}}<br>
                    Site web : {{company_website}}
                  </td>
                </tr>
                <tr>
                  <td style="padding-top:18px; font-size:12px; line-height:20px; color:#6b7280;">
                    © {{current_year}} Couteau Suisse Digital. Tous droits réservés.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Nous confirmons que votre achat a bien été enregistré chez Couteau Suisse Digital.

Commande: {{order_number}}
Date: {{order_date}}
Service: {{product_name}}
Montant total: {{total_price}}
Mode de paiement: {{payment_method}}

Voir ma commande: {{order_url}}
Besoin d’aide: {{support_url}}

Couteau Suisse Digital
Email: {{company_email}}
Téléphone: {{company_phone}}
Site web: {{company_website}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'admin_new_order',
    name: 'Nouvelle commande admin',
    alias: 'checkout-admin-new-order',
    subject: 'Nouvelle commande reçue — {{product_name}}',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Nouvelle commande</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Alerte interne</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:42px 32px 32px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Nouvelle commande</div>
              <div style="font-size:34px; line-height:42px; font-weight:800; color:#111827; padding-bottom:18px;">Une commande vient d’être validée.</div>
              <div style="font-size:17px; line-height:28px; color:#4b5563;">
                {{customer_name}} a finalisé l’achat de <strong>{{product_name}}</strong> pour <strong>{{total_price}}</strong>.
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table width="100%" role="presentation">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Client</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{customer_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Email</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{customer_email}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Téléphone</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{client_phone}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Pays</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{client_country}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Commande</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{order_number}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Token</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{checkout_token}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:20px 32px 28px 32px; background:#111827; color:#d1d5db; font-size:13px; line-height:22px;">
              Envoyé automatiquement par Couteau Suisse Digital.
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Nouvelle commande validée.

Client: {{customer_name}}
Email: {{customer_email}}
Téléphone: {{client_phone}}
Pays: {{client_country}}
Produit: {{product_name}}
Montant: {{total_price}}
Commande: {{order_number}}
Token: {{checkout_token}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'payment_reminder',
    name: 'Rappel de paiement en attente',
    alias: 'checkout-payment-reminder',
    subject: 'Votre paiement pour {{product_name}} est toujours en attente',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Rappel de paiement</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Paiement en attente</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Votre commande peut encore être finalisée.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Votre demande pour <strong>{{product_name}}</strong> est toujours disponible. Vous pouvez reprendre le paiement en quelques clics.
              </div>
              <a href="{{checkout_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Finaliser mon paiement
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table width="100%" role="presentation">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Service</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{product_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Montant</td>
                        <td align="right" style="font-size:18px; font-weight:800; color:#ff6a00;">{{total_price}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Besoin d’aide ?</strong><br>
                    Notre équipe peut répondre rapidement à vos questions avant validation.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Contacter le support
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Votre paiement pour {{product_name}} est toujours en attente.
Montant: {{total_price}}
Lien de paiement: {{checkout_url}}
Support: {{support_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'abandoned_cart',
    name: 'Panier abandonné',
    alias: 'checkout-abandoned-cart',
    subject: 'Votre sélection vous attend encore',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Panier abandonné</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Panier abandonné</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Votre sélection vous attend.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Nous avons remarqué que vous avez commencé votre commande sans la finaliser. Votre sélection est toujours disponible.
              </div>
              <a href="{{checkout_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Finaliser ma commande
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:30px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:18px;">Votre sélection</div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table width="100%" role="presentation">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Service / Offre</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{product_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Montant</td>
                        <td align="right" style="font-size:18px; font-weight:800; color:#ff6a00; padding-bottom:8px;">{{total_price}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Lien direct</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{checkout_url}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Besoin d’aide ?</strong><br>
                    Si vous avez une question avant de finaliser, notre équipe peut vous répondre rapidement.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Contacter le support
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Votre sélection est toujours disponible chez Couteau Suisse Digital.
Service: {{product_name}}
Montant: {{total_price}}
Reprendre mon panier: {{checkout_url}}
Support: {{support_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'payment_failed',
    name: 'Paiement échoué',
    alias: 'checkout-payment-failed',
    subject: 'Action requise pour finaliser votre commande',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Paiement échoué</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Paiement non finalisé</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Votre commande attend toujours votre validation.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Nous n’avons pas pu finaliser le paiement pour <strong>{{product_name}}</strong>. Vous pouvez relancer le processus à tout moment.
              </div>
              <a href="{{checkout_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Relancer mon paiement
              </a>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Contacter le support
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Nous n’avons pas pu finaliser votre paiement pour {{product_name}}.
Relancer mon paiement: {{checkout_url}}
Support: {{support_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'invoice',
    name: 'Facture',
    alias: 'checkout-invoice',
    subject: 'Votre facture — Couteau Suisse Digital',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Votre facture</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1; margin:0; padding:0;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background-color:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; background-color:#ffffff; border-bottom:1px solid #f1ece8;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td align="left" style="font-size:38px; font-weight:800; color:#ff6a00; letter-spacing:-1px;">
                    CSD
                  </td>
                  <td align="right" style="font-size:13px; color:#6b7280;">
                    Couteau Suisse Digital
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td align="left" style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">
                    Facture
                  </td>
                </tr>
                <tr>
                  <td align="left" style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">
                    Votre facture est disponible.
                  </td>
                </tr>
                <tr>
                  <td align="left" style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                    Bonjour {{customer_first_name}},<br><br>
                    Merci pour votre confiance. Veuillez trouver ci-dessous le récapitulatif de votre facture pour les services de <strong>Couteau Suisse Digital</strong>.
                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <a href="{{invoice_url}}" style="display:inline-block; background-color:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                      Télécharger la facture
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:34px 32px 10px 32px;">
              <div style="font-size:24px; line-height:32px; font-weight:800; color:#111827; margin-bottom:20px;">
                Informations de facturation
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Numéro de facture</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{invoice_number}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Date de facturation</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{invoice_date}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Client</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{customer_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Email</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{customer_email}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Mode de paiement</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{payment_method}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:24px 32px 10px 32px;">
              <div style="font-size:24px; line-height:32px; font-weight:800; color:#111827; margin-bottom:18px;">
                Détail de la facture
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="border:1px solid #f0e8e2; border-radius:16px; overflow:hidden;">
                <tr style="background-color:#fff4eb;">
                  <td style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Description</td>
                  <td align="center" style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Qté</td>
                  <td align="right" style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Prix</td>
                </tr>
                <tr>
                  <td style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{service_name}}</td>
                  <td align="center" style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{quantity}}</td>
                  <td align="right" style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{line_total}}</td>
                </tr>
                <tr>
                  <td colspan="3" style="padding:0 18px;">
                    <div style="height:1px; background-color:#f3ece7;"></div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:14px 18px 8px 18px; font-size:14px; color:#6b7280;">Sous-total</td>
                  <td align="right" style="padding:14px 18px 8px 18px; font-size:14px; font-weight:700; color:#111827;">{{subtotal}}</td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:0 18px 8px 18px; font-size:14px; color:#6b7280;">Taxes</td>
                  <td align="right" style="padding:0 18px 8px 18px; font-size:14px; font-weight:700; color:#111827;">{{tax_amount}}</td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:0 18px 18px 18px; font-size:16px; font-weight:800; color:#111827;">Total</td>
                  <td align="right" style="padding:0 18px 18px 18px; font-size:20px; font-weight:800; color:#ff6a00;">{{total_amount}}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Note :</strong><br>
                    Conservez cette facture pour vos dossiers. Si vous avez une question concernant la facturation, notre équipe reste disponible.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:30px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Contacter le support
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background-color:#111827;">
              <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                <tr>
                  <td style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">
                    CSD
                  </td>
                </tr>
                <tr>
                  <td style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                    Couteau Suisse Digital<br>
                    Des solutions numériques pensées pour faire avancer votre entreprise.
                  </td>
                </tr>
                <tr>
                  <td style="font-size:13px; line-height:22px; color:#9ca3af;">
                    Email : {{company_email}}<br>
                    Téléphone : {{company_phone}}<br>
                    Site web : {{company_website}}
                  </td>
                </tr>
                <tr>
                  <td style="padding-top:18px; font-size:12px; line-height:20px; color:#6b7280;">
                    © {{current_year}} Couteau Suisse Digital. Tous droits réservés.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Votre facture est disponible.

Facture: {{invoice_number}}
Date: {{invoice_date}}
Client: {{customer_name}}
Email: {{customer_email}}
Mode de paiement: {{payment_method}}
Service: {{service_name}}
Quantité: {{quantity}}
Sous-total: {{subtotal}}
Taxes: {{tax_amount}}
Total: {{total_amount}}

Télécharger la facture: {{invoice_url}}
Support: {{support_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'welcome',
    name: 'Bienvenue',
    alias: 'checkout-welcome',
    subject: 'Bienvenue chez Couteau Suisse Digital',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bienvenue</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Bienvenue</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Bienvenue chez Couteau Suisse Digital.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Merci de nous rejoindre. Nous sommes ravis de vous accompagner avec des solutions numériques conçues pour faire évoluer votre activité.
              </div>
              <a href="{{dashboard_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Accéder à mon espace
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:30px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:16px;">Vos prochaines étapes</div>
              <div style="font-size:16px; line-height:28px; color:#4b5563;">
                1. Activez votre espace client<br>
                2. Vérifiez vos informations<br>
                3. Réservez votre premier échange si nécessaire<br>
                4. Lancez votre projet avec notre équipe
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Bon à savoir :</strong><br>
                    Si vous avez besoin d’un accompagnement rapide, vous pouvez réserver un appel avec notre équipe à tout moment.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{booking_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Réserver un appel
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Bienvenue chez Couteau Suisse Digital.

Accéder à mon espace: {{dashboard_url}}
Réserver un appel: {{booking_url}}

Email: {{company_email}}
Téléphone: {{company_phone}}
Site web: {{company_website}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'upcoming_billing_reminder',
    name: 'Rappel de prélèvement à venir',
    alias: 'checkout-upcoming-billing-reminder',
    subject: 'Rappel abonnement J-{{days_before_payment}} — prélèvement prévu le {{billing_date}}',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Rappel de prélèvement</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Rappel de paiement</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Un prélèvement est prévu prochainement.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Nous vous informons qu’un paiement de <strong>{{amount_with_currency}}</strong> sera prélevé sur votre compte le <strong>{{billing_date}}</strong> pour le service <strong>{{service_name}}</strong>.
              </div>
              <div style="font-size:14px; line-height:24px; color:#6b7280; padding-bottom:24px;">
                Abonnement {{subscription_number}} • {{subscription_interval}}
              </div>
              <a href="{{billing_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Voir mes informations de paiement
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:30px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:18px;">Détail du prélèvement</div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table width="100%" role="presentation">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Service</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{service_name}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Montant</td>
                        <td align="right" style="font-size:18px; font-weight:800; color:#ff6a00; padding-bottom:8px;">{{amount_with_currency}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Date prévue</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{billing_date}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Abonnement</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{subscription_number}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Mode de paiement</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{payment_method}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Important :</strong><br>
                    Si vous souhaitez mettre à jour votre moyen de paiement ou avez une question, merci de le faire avant la date prévue de prélèvement.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{support_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Contacter le support
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Un prélèvement de {{amount_with_currency}} est prévu le {{billing_date}} pour {{service_name}}.
Abonnement: {{subscription_number}} ({{subscription_interval}})
Jours restants: {{days_before_payment}}

Voir mes informations de paiement: {{billing_url}}
Support: {{support_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel({
      billing_date: '30 avril 2026',
      days_before_payment: '3',
      subscription_number: 'SUB-2026-0195',
      subscription_interval: 'Mensuel',
    }),
  },
  {
    templateKey: 'custom_modular',
    name: 'Template custom modulaire',
    alias: 'csd-custom-modular',
    subject: '{{email_title}}',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>{{email_title}}</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">
                {{email_label}}
              </div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">
                {{hero_title}}
              </div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                {{hero_text}}
              </div>
              <a href="{{primary_button_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                {{primary_button_text}}
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:30px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:16px;">{{section_title}}</div>
              <div style="font-size:16px; line-height:28px; color:#4b5563;">
                {{section_text}}
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px; font-size:15px; line-height:26px; color:#4b5563;">
                    {{box_content}}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">{{note_title}}</strong><br>
                    {{note_text}}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{secondary_button_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                {{secondary_button_text}}
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:10px 32px 20px 32px;">
              {{custom_html_block}}
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `{{email_label}}

{{hero_title}}

{{hero_text}}

{{section_title}}
{{section_text}}

{{box_content}}

{{note_title}}
{{note_text}}

Action principale: {{primary_button_url}}
Action secondaire: {{secondary_button_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
  {
    templateKey: 'quote',
    name: 'Devis',
    alias: 'checkout-quote',
    subject: 'Votre devis — Couteau Suisse Digital',
    htmlBody: `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Votre devis</title>
</head>
<body style="margin:0; padding:0; background-color:#f5f3f1; font-family:Arial, Helvetica, sans-serif; color:#1f2937;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f3f1;">
    <tr>
      <td align="center" style="padding:30px 15px;">
        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:640px; background:#ffffff; border-radius:20px; overflow:hidden; box-shadow:0 8px 30px rgba(0,0,0,0.06);">
          <tr>
            <td style="padding:28px 32px; border-bottom:1px solid #f1ece8;">
              <table width="100%" role="presentation">
                <tr>
                  <td style="font-size:38px; font-weight:800; color:#ff6a00;">CSD</td>
                  <td align="right" style="font-size:13px; color:#6b7280;">Couteau Suisse Digital</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="background:linear-gradient(180deg, #f7f3ef 0%, #fffaf7 100%); padding:50px 32px 38px 32px;">
              <div style="font-size:15px; font-weight:700; color:#ff6a00; text-transform:uppercase; letter-spacing:1px; padding-bottom:14px;">Devis</div>
              <div style="font-size:38px; line-height:46px; font-weight:800; color:#111827; padding-bottom:18px;">Votre devis est prêt.</div>
              <div style="font-size:18px; line-height:30px; color:#4b5563; padding-bottom:24px;">
                Bonjour {{customer_first_name}},<br><br>
                Merci pour votre intérêt. Vous trouverez ci-dessous le récapitulatif du devis préparé par notre équipe.
              </div>
              <a href="{{quote_url}}" style="display:inline-block; background:#ff6a00; color:#ffffff; text-decoration:none; font-size:16px; font-weight:700; padding:16px 28px; border-radius:999px;">
                Voir le devis
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:30px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:18px;">Informations du devis</div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#faf7f4; border:1px solid #f0e8e2; border-radius:16px;">
                <tr>
                  <td style="padding:22px 24px;">
                    <table width="100%" role="presentation">
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Numéro de devis</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{quote_number}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Date</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{quote_date}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280; padding-bottom:8px;">Validité</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827; padding-bottom:8px;">{{quote_valid_until}}</td>
                      </tr>
                      <tr>
                        <td style="font-size:14px; color:#6b7280;">Client</td>
                        <td align="right" style="font-size:14px; font-weight:700; color:#111827;">{{customer_name}}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:24px 32px 10px 32px;">
              <div style="font-size:24px; font-weight:800; color:#111827; margin-bottom:18px;">Détail</div>
            </td>
          </tr>
          <tr>
            <td style="padding:0 32px 10px 32px;">
              <table width="100%" role="presentation" style="border:1px solid #f0e8e2; border-radius:16px; overflow:hidden;">
                <tr style="background:#fff4eb;">
                  <td style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Description</td>
                  <td align="center" style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Qté</td>
                  <td align="right" style="padding:14px 18px; font-size:13px; font-weight:700; color:#7c4a22;">Prix</td>
                </tr>
                <tr>
                  <td style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{service_name}}</td>
                  <td align="center" style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{quantity}}</td>
                  <td align="right" style="padding:16px 18px; font-size:14px; color:#111827; border-top:1px solid #f3ece7;">{{line_total}}</td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:14px 18px 8px 18px; font-size:14px; color:#6b7280;">Sous-total</td>
                  <td align="right" style="padding:14px 18px 8px 18px; font-size:14px; font-weight:700; color:#111827;">{{subtotal}}</td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:0 18px 8px 18px; font-size:14px; color:#6b7280;">Taxes</td>
                  <td align="right" style="padding:0 18px 8px 18px; font-size:14px; font-weight:700; color:#111827;">{{tax_amount}}</td>
                </tr>
                <tr>
                  <td colspan="2" align="right" style="padding:0 18px 18px 18px; font-size:16px; font-weight:800; color:#111827;">Total</td>
                  <td align="right" style="padding:0 18px 18px 18px; font-size:20px; font-weight:800; color:#ff6a00;">{{total_amount}}</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding:22px 32px 10px 32px;">
              <table width="100%" role="presentation" style="background:#fff4eb; border-left:4px solid #ff6a00; border-radius:12px;">
                <tr>
                  <td style="padding:18px 20px; font-size:15px; line-height:26px; color:#7c4a22;">
                    <strong style="color:#111827;">Validité du devis :</strong><br>
                    Ce devis est valable jusqu’au {{quote_valid_until}}. Passé ce délai, il pourra être révisé.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="padding:28px 32px 20px 32px;">
              <a href="{{accept_quote_url}}" style="display:inline-block; color:#111827; text-decoration:none; font-size:15px; font-weight:700;">
                Accepter ce devis
              </a>
            </td>
          </tr>
          <tr>
            <td style="padding:28px 32px; background:#111827;">
              <div style="font-size:24px; font-weight:800; color:#ff6a00; padding-bottom:12px;">CSD</div>
              <div style="font-size:14px; line-height:24px; color:#d1d5db; padding-bottom:14px;">
                Couteau Suisse Digital<br>
                Des solutions numériques pensées pour faire avancer votre entreprise.
              </div>
              <div style="font-size:13px; line-height:22px; color:#9ca3af;">
                Email : {{company_email}}<br>
                Téléphone : {{company_phone}}<br>
                Site web : {{company_website}}
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`.trim(),
    textBody: `Bonjour {{customer_first_name}},

Votre devis est prêt.

Devis: {{quote_number}}
Date: {{quote_date}}
Validité: {{quote_valid_until}}
Client: {{customer_name}}
Service: {{service_name}}
Quantité: {{quantity}}
Sous-total: {{subtotal}}
Taxes: {{tax_amount}}
Total: {{total_amount}}

Voir le devis: {{quote_url}}
Accepter ce devis: {{accept_quote_url}}`,
    messageStream,
    fromEmail,
    replyTo,
    active: true,
    sampleModel: createSampleModel(),
  },
];

export const getDefaultEmailFlowPresets = ({
  messageStream = DEFAULT_EMAIL_MESSAGE_STREAM,
} = {}) => [
  {
    flowKey: 'purchase_confirmation',
    name: 'Confirmation achat client',
    description: 'Envoyé au client dès que le paiement est confirmé.',
    triggerType: 'payment_paid',
    recipientType: 'customer',
    templateAlias: 'checkout-purchase-confirmation',
    messageStream,
    delayMinutes: 0,
    maxSends: 1,
    enabled: true,
  },
  {
    flowKey: 'admin_new_order',
    name: 'Alerte nouvelle commande',
    description: 'Prévient l’admin dès qu’une commande est confirmée.',
    triggerType: 'payment_paid',
    recipientType: 'admin',
    templateAlias: 'checkout-admin-new-order',
    messageStream,
    delayMinutes: 0,
    maxSends: 1,
    enabled: true,
  },
  {
    flowKey: 'abandoned_cart',
    name: 'Relance panier abandonné',
    description: 'Relance une session de paiement non terminée après 60 minutes.',
    triggerType: 'checkout_abandoned',
    recipientType: 'customer',
    templateAlias: 'checkout-abandoned-cart',
    messageStream,
    delayMinutes: 60,
    maxSends: 2,
    enabled: true,
  },
  {
    flowKey: 'payment_reminder',
    name: 'Rappel paiement 24h',
    description: 'Rappel additionnel si le paiement est toujours en attente après 24h.',
    triggerType: 'payment_pending',
    recipientType: 'customer',
    templateAlias: 'checkout-payment-reminder',
    messageStream,
    delayMinutes: 1440,
    maxSends: 2,
    enabled: true,
  },
  {
    flowKey: 'payment_failed',
    name: 'Paiement échoué',
    description: 'Recontacte le client après expiration ou échec du checkout.',
    triggerType: 'payment_failed',
    recipientType: 'customer',
    templateAlias: 'checkout-payment-failed',
    messageStream,
    delayMinutes: 15,
    maxSends: 1,
    enabled: true,
  },
  {
    flowKey: 'welcome_customer',
    name: 'Bienvenue client',
    description: 'Template prêt à activer pour un email de bienvenue après achat.',
    triggerType: 'payment_paid',
    recipientType: 'customer',
    templateAlias: 'checkout-welcome',
    messageStream,
    delayMinutes: 5,
    maxSends: 1,
    enabled: false,
  },
  {
    flowKey: 'invoice_customer',
    name: 'Facture client',
    description: 'Template prêt à activer pour envoyer une facture après achat.',
    triggerType: 'payment_paid',
    recipientType: 'customer',
    templateAlias: 'checkout-invoice',
    messageStream,
    delayMinutes: 10,
    maxSends: 1,
    enabled: false,
  },
];
